<template>
	<section class="page-overlay"></section>
</template>
